import JOTLogo from "../Icons/jotLogo.png";

type JustOneTreeInfoProps = {
  treesPlanted: number | undefined;
}
const JustOneTreeInfo = ({treesPlanted}: JustOneTreeInfoProps) => {
  return <div
    className="rounded-lg bg-my-olive text-white bg-opacity-80 flex p-2 text-center leading-none space-x-2"
  >
    <div className="flex-none my-auto">
      <img src={JOTLogo} alt="Just One Tree" className="w-24" />
    </div>
    <div className="flex-1 my-auto">
      <div className="block text-5xl tracking-tighter">
        {treesPlanted !== undefined ? treesPlanted : 0}
      </div>
      <div className="text-sm text-nowrap">
        Trees Donated
      </div>
    </div>
    <div className="flex-1 my-auto">
      <span className="block text-5xl text-nowrap">
        {treesPlanted !== undefined ? treesPlanted*25 : 0}
        <span className="text-sm">
          kg/yr
        </span>
      </span>
      <span className="text-sm">
        CO<sub className="">2</sub> Removed
      </span>
    </div>
  </div>
}

export default JustOneTreeInfo